export default __webpack_public_path__ + "static/media/okg-loading-logo.073f6dff.gif";